var React = require('react');

function TD (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"TD logo"),React.createElement("rect",{"x":"0","y":"140","width":"200","height":"120","key":1}),React.createElement("rect",{"x":"0","y":"140","width":"120","height":"260","key":2}),React.createElement("path",{"d":"M252.893,400c16.618,-14.663 27.107,-36.116 27.107,-60c0,0 120,0 120,0c0,20.9 -3.213,41.056 -9.171,60l-137.936,0Z","key":3}),React.createElement("path",{"d":"M200,140c110.383,0 200,89.617 200,200c0,0 -120,0 -120,0c0,-44.153 -35.847,-80 -80,-80l0,-120Z","key":4}),React.createElement("rect",{"x":"0","y":"0","width":"400","height":"120","key":5}),React.createElement("path",{"d":"M260,110l-120,0l0,290l59.87,0c33.186,0 60.13,-26.944 60.13,-60.13l0,-229.87Z","key":6})]);
}

TD.defaultProps = {"role":"img","viewBox":"0 0 400 400"};

module.exports = TD;

TD.default = TD;
